import { BLACK_FRIDAY_SHOW_MODAL_PATH_ALLOW_LIST } from '../constants';

const isShowModalForPathname = (path: string): boolean => {
  return BLACK_FRIDAY_SHOW_MODAL_PATH_ALLOW_LIST.some((allowedPath) =>
    path.startsWith(allowedPath),
  );
};

export default isShowModalForPathname;
